import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import _toConsumableArray from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import Sortable from "sortablejs";
export default {
  data: function data() {
    return {
      language: [{
        label: '简体中文',
        value: 'cn'
      }, {
        label: '繁体中文',
        value: 'tc'
      }, {
        label: '英文',
        value: 'en'
      }, {
        label: '越南',
        value: 'vn'
      }],
      platformTypeList: [{
        label: '安卓',
        value: 'android'
      }, {
        label: '苹果',
        value: 'ios'
      }],
      delIds: [],
      tableBody: '',
      sortReq: '',
      languageList: []
    };
  },
  mounted: function mounted() {
    this.tableBody && this.initSort(this.tableBody, this.sortReq);
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    getlangList: function getlangList() {
      var _this = this;

      this.$api.languageInfoData().then(function (res) {
        if (res.code == 0) {
          _this.languageList = res.data;
        }
      });
    },
    initSort: function initSort(type, reqFn) {
      var _this2 = this;

      var el = document.querySelectorAll(".".concat(type, " .el-table__body-wrapper > table > tbody"))[0];
      this.sortable = new Sortable(el, {
        animation: 150,
        delay: 0,
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
              oldIndex = _ref.oldIndex;

          var tableList = _toConsumableArray(_this2.pagingList);

          var temp;
          temp = tableList[oldIndex];
          tableList.splice(oldIndex, 1);
          tableList.splice(newIndex, 0, temp);
          var newList = tableList.map(function (i) {
            return i.sort;
          });
          newList.sort(function (a, b) {
            return a - b;
          });
          newList.reverse();
          tableList.map(function (i, index) {
            i.sort = newList[index];
          });
          _this2.pagingList = [];

          _this2.$api[reqFn]({
            sort_data: tableList
          });

          _this2.$nextTick(function () {
            _this2.pagingList = tableList;
          });
        }
      });
    }
  }
};